import React, { forwardRef } from 'react';

export type VideoPlayerProps = React.VideoHTMLAttributes<HTMLVideoElement>;

export const VideoPlayer = forwardRef<HTMLVideoElement, VideoPlayerProps>(
  ({ playsInline = true, controls = false, preload = 'metadata', style, ...props }, ref) => {
    return (
      <video
        ref={ref}
        playsInline={playsInline}
        controls={controls}
        preload={preload}
        style={{
          width: '100%',
          height: 'auto',
          display: 'block',
          backgroundColor: 'black',
          ...style,
        }}
        {...props}
      />
    );
  }
);

VideoPlayer.displayName = 'VideoPlayer';
